import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoaderService } from 'src/app/services/loader-service/loader.service';
import { CommonService } from 'src/app/services/common-service/common.service';
import { isNullOrUndefined } from 'is-what';
import { Subscription } from 'rxjs';
import { isPresent } from 'src/app/utils/utils';
import { CommonModule } from '@angular/common';
import { NgxLoadingModule } from 'ngx-loading-reloaded';
import { environment } from 'src/environments/environment';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'gsti-loader',
  templateUrl: './gsti-loader.component.html',
  styleUrls: ['./gsti-loader.component.scss'],
  imports: [NgxLoadingModule, CommonModule, ProgressSpinnerModule]
})
export class GstiLoaderComponent implements OnInit, OnDestroy {
  loading!: boolean;
  loadingmessage: any = '';
  leftpadding: any = 0;
  rightpadding: number = 0;
  bottompadding: number = 0;
  loaderThemeSelector: number = 1;
  loaderSubscription: Subscription;
  constructor(public loaderService: LoaderService, public commonservice: CommonService) {
    this.loaderSubscription = this.commonservice.getLoadingMessageLoader().subscribe(data => {
      let msg: any = data;
      //console.log('lodermsg:',msg);
      if (!isNullOrUndefined(msg)) {
        if (msg == '') {
          this.loading = false;
        }
        else {
          if (msg != '') {
            let newmsg = `  ` + msg + `  `;
            this.commonservice.ogLog('mew:', newmsg),
              this.loadingmessage = newmsg;
          }

        }
      }

    });
    this.loaderService.isLoading.subscribe((v) => {
      //console.log('loader...', v);
      this.loading = v;
      if (this.loading == false) {
        this.loadingmessage = '';
        this.commonservice.setLoadingMessageLoader('');
      }

    });

  }

  ngOnInit(): void {
    this.loaderThemeSelector = environment.loaderThemeSelector;
  }

  ngOnDestroy(): void {
    if (isPresent(this.loaderSubscription))
      this.loaderSubscription.unsubscribe();
  }

}